import React from 'react';
import Link from 'next/link';
import ThumbnailImage from './thumbnail';
import Date from './date';

import { H3, Muted } from './text';
import { IFeaturedImage } from '../models/featured-image';

interface IProps {
	title: string;
	date: string;
	coverImage: IFeaturedImage;
	baseSlug: string;
	slug: string;
}

export default function FeaturedVideoHeroPost({
	title,
	date,
	coverImage,
	baseSlug,
	slug,
}: IProps) {
	return (
		<section>
			<div className="relative w-full rounded-sm">
				{coverImage && (
					<Link href={`/${baseSlug}/${slug}`}>
						<ThumbnailImage
							title={title}
							coverImage={coverImage}
							classNames="block aspect-video object-cover rounded-sm hover:opacity-75 transition-opacity"
							overlay={false}
							videoAspectMobile
						/>
					</Link>
				)}
			</div>
			<div className="mt-3">
				<Link href={`/${baseSlug}/${slug}`}>
					<H3 className="text-white mb-1 hover:underline">{title}</H3>
				</Link>
				<Muted>
					<Date dateString={date} />
				</Muted>
			</div>
		</section>
	);
}
